import { render, staticRenderFns } from "./MobileJoinMeetingFromLinkScreen.vue?vue&type=template&id=25fafdec&scoped=true"
import script from "./MobileJoinMeetingFromLinkScreen.vue?vue&type=script&lang=js"
export * from "./MobileJoinMeetingFromLinkScreen.vue?vue&type=script&lang=js"
import style0 from "./MobileJoinMeetingFromLinkScreen.vue?vue&type=style&index=0&id=25fafdec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fafdec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25fafdec')) {
      api.createRecord('25fafdec', component.options)
    } else {
      api.reload('25fafdec', component.options)
    }
    module.hot.accept("./MobileJoinMeetingFromLinkScreen.vue?vue&type=template&id=25fafdec&scoped=true", function () {
      api.rerender('25fafdec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/MobileJoinMeetingFromLinkScreen.vue"
export default component.exports